import type {
  TargetedBrandSpecialProps,
  TargetedBrandSpecialsProps,
} from './targetedBrandSpecials.types';

export const targetedBrandSpecialsKeys = {
  brandSpecial: (params: TargetedBrandSpecialProps) => [
    'brandSpecials',
    params,
  ],
  brandSpecials: (params: TargetedBrandSpecialsProps) => [
    'brandSpecials',
    params,
  ],
  infiniteBrandSpecials: (params: {
    perPage: number;
    storeIds: (string | number)[];
  }) => ['infiniteBrandSpecials', params],
};
